import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { KioskLockRedirect } from '../utils/kioskAccount';
import Button from './ui/Button';
import Modal from './ui/Modal';

function buildLoginPathWithNext(location) {
    const nextPath = `${location?.pathname || '/'}${location?.search || ''}${location?.hash || ''}`;
    // Codifica o valor inteiro, mas devolve as barras para a URL ficar legível na barra de endereço
    // ("/" é permitido em query string pela RFC 3986). Os demais reservados (?, &, =, #) continuam
    // escapados; URLSearchParams no Login decodifica os dois formatos do mesmo jeito.
    const visibleNext = encodeURIComponent(nextPath).replace(/%2F/gi, '/');
    return `/login?next=${visibleNext}`;
}

const ProtectedRoute = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, isAuthenticated, loading, sessionExpired, acknowledgeSessionExpired } = useAuth();
    const loginPath = buildLoginPathWithNext(location);

    const handleGoToLogin = () => {
        acknowledgeSessionExpired();
        navigate(loginPath, { replace: true });
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-mono-600 dark:text-mono-400">Carregando...</div>
            </div>
        );
    }

    if (sessionExpired) {
        return (
            <Modal
                isOpen
                onClose={handleGoToLogin}
                title="Sessão expirada"
                showCloseButton={false}
                size="sm"
                actions={
                    <Button type="button" className="w-full" onClick={handleGoToLogin}>
                        Ir para login
                    </Button>
                }
            >
                <p className="text-mono-700 dark:text-mono-300">
                    Não foi possível validar a sua sessão. Faça login novamente para continuar.
                </p>
            </Modal>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to={loginPath} replace />;
    }

    // TRAVA DO QUIOSQUE: conta de terminal (só `wms:operate`) vive no posto
    // dela — /bancada no monitor, /coletor no Android. Qualquer outra rota
    // autenticada (Layout, /warehouse/*, /profile, 404, `?next=` do login)
    // volta ao posto. Mora AQUI porque este componente embrulha toda rota
    // autenticada: um lugar só, sem depender de cada página lembrar.
    const kioskTarget = KioskLockRedirect(user?.permissions, location.pathname, window.innerWidth);
    if (kioskTarget) {
        return <Navigate to={kioskTarget} replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
